import React from "react";
import { string } from "prop-types";

import ErrorMessage from "../../../../shared/components/ErrorMessage";
import ValuationContainer from "../ValuationContainer";
import * as S from "./styled";

const ValuationError = ({ className }) => (
  <ValuationContainer className={className}>
    <S.ErrorContainer>
      <ErrorMessage />
    </S.ErrorContainer>
  </ValuationContainer>
);

ValuationError.propTypes = {
  className: string
};

ValuationError.defaultProps = {
  className: ""
};

export default ValuationError;
